import { createContext, useContext } from 'react'

const searchQueryContext = createContext(null)

export default searchQueryContext

export const useSearchQueryContext = () => {
    const [query, setQuery] = useContext(searchQueryContext)
    return { query, setQuery }
}